import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { LazyDiv } from 'components/common/LazyHtml'

const LinkProductContentSpotlightXMSlot = ({ content, ...props }) =>
  <ContentSpotlights content={ content } />

LinkProductContentSpotlightXMSlot.propTypes = {
  '@type': PropTypes.string,
  content: PropTypes.string,
  'endeca:auditInfo': PropTypes.shape({
    'ecr:innerPath': PropTypes.string,
    'ecr:resourcePath': PropTypes.string
  }),
  name: PropTypes.string
}

LinkProductContentSpotlightXMSlot.type = 'ProductContentSpotlight-XMSlot'

export default LinkProductContentSpotlightXMSlot

const ContentSpotlights = styled(LazyDiv)`
  display: table-cell;
  vertical-align: top;
`
